
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/government",
      function () {
        return require("private-next-pages/solutions/government.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/government"])
      });
    }
  